//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'batch_service',
  data() {
    return {
      buttonTabVal: 0,
      base_info: {
        id: this.$route.query.id,
        name: '',
        phone: '',
        package: '',
        macheck_id: '',
        leave_id: '', //出院
        checklist_id: '', //月子期间医院就诊单
      },
      baby_list: [],
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: './maternal_file',
      })
    },
    toBatchRecord() {
      this.$router.push({
        path: './batch_record',
      })
    },
  },
  created() {},
}



// WEBPACK FOOTER //
// ./src/components/batch_service.vue